import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import MegaMenu from './mega-menu'

import {FormattedMessage} from 'react-intl';

class MainNavigation extends Component {
    constructor(props) {
        super(props);
        this.otherMenuToggle = this.otherMenuToggle.bind(this);
        this.menuToggle = this.menuToggle.bind(this);
        this.navigationGenerate = this.navigationGenerate.bind(this);
        this.closeMenu = this.closeMenu.bind(this);

    }

    otherMenuToggle() {
        let showMenu = this.props.showOtherMenu ? false : true,
            showOtherMenu = this.props.showOtherMenu ? false : true;
        this.props.handleNavigation(showOtherMenu, showMenu);
    }

    menuToggle() {
        this.props.handleNavigation(false, !this.props.showMenu);
    }

    closeMenu() {
        this.props.handleNavigation(false, false);
    }

    // <FormattedMessage id={menuTitle}/>

    hasAccess(element){
        return this.props.privileges[element.title] !== null && this.props.privileges[element.title] !== "no access";
    }
    navigationGenerate() {
        return this.props.navigation.mainNavigation.map((value, key) => {
            if (value.showMainMenu && this.hasAccess(value)) {
                return <Link  key={key} onClick={this.closeMenu} className="link" to={value.link} title={value.title}>
                    <svg className="icon" dangerouslySetInnerHTML={{__html: value.icon}}/>
                    <span className="menu-title"><FormattedMessage id={value.title}/></span>
                </Link>
            }
            return null;
        });
    }

    render() {

        let mainNavigationClass = 'main-navigation';

        if (this.props.showOtherMenu || this.props.showMenu) {
            mainNavigationClass += ' open';
        }

        return (
            <div className="main-navigation-area">
                <Link to="/" title="Dash Frontend" className="logo">
                    <img src={process.env.PUBLIC_URL + '/img/template/logo-mainmenu.svg'} alt="Logo"/>
                </Link>
                <nav className={mainNavigationClass}>
                    <span
                        className={this.props.showOtherMenu ? 'active link' : 'link'}
                        onClick={this.otherMenuToggle}>
                        <svg className="icon">
                            <path d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
                        </svg>
                        <span className="menu-title"><FormattedMessage id="Menu"/></span>
                    </span>
                    {this.navigationGenerate()}

                   
                    <MegaMenu visible={this.props.showOtherMenu}/>
                </nav>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        navigation: state.navigation
    }
}

export default connect(mapStateToProps)(MainNavigation);
